import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';

/*
  Generated class for the SceneProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SceneProvider {
  levelPath;
  constructor(public http: HttpClient, private platform: Platform) {
    console.log('Hello SceneProvider Provider');
    if(this.platform.is('cordova')){
      this.levelPath = '../www/assets/imgs/';
    } else {
      this.levelPath = '../../assets/imgs/';
    }
  }

  getImageData(key) {
    const num = key.split('.')[0];
    return this.http.get(this.levelPath + num + '.json');
  }

}



// WEBPACK FOOTER //
// ./src/providers/scene/scene.ts